import { Helmet } from 'react-helmet-async'
import { getAnimeImage } from '../../services/util.service'

export function AnimeDetailsHelmet({ anime }) {
  if (!anime) return null

  const title = anime.title_hebrew || anime.title_english || anime.title

  const description =
    anime.synopsis_hebrew ||
    anime.synopsis ||
    `מידע על ${title} כולל תקציר, דירוג, דמויות, טריילר והיכן ניתן לצפות באנימה.`

  const image = getAnimeImage(anime)

  const url = `https://www.anizone.co.il/anime/${
    anime.mal_id
  }/${encodeURIComponent(anime.title_english || anime.title)}`

  const keywords = `אנימה, ${title}, תקציר ${title}, דמויות ${title}, ${title} בעברית, צפייה ב-${title}, אניזון, AniZone, אתר אנימה ישראלי`

  return (
    <Helmet>
      {/* 🧠 כותרת נקייה וממוקדת */}
      <title>{`${title} - AniZone`}</title>

      {/* 📄 תיאור */}
      <meta name="description" content={description} />

      {/* 🗝️ מילות מפתח */}
      <meta name="keywords" content={keywords} />

      {/* 🔗 קנוניקל */}
      <link rel="canonical" href={url} />

      {/* 📱 Open Graph */}
      <meta property="og:title" content={`${title} - AniZone`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />

      {/* 🐦 Twitter Cards */}
      <meta name="twitter:title" content={`${title} - AniZone`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* 🧩 JSON-LD Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'TVSeries',
            name: title,
            description,
            image,
            url,
            inLanguage: 'he',
            sameAs: [`https://myanimelist.net/anime/${anime.mal_id}`],
            genre: anime.genres?.map((genre) => genre.name) || ['Anime'],
            productionCompany: {
              '@type': 'Organization',
              name: anime.studios?.[0]?.name || 'Unknown Studio',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: anime.score || 0,
              ratingCount: anime.scored_by || 0,
            },
            trailer: anime.trailer?.embed_url
              ? {
                  '@type': 'VideoObject',
                  name: `${title} - טריילר`,
                  embedUrl: anime.trailer.embed_url,
                  thumbnailUrl: anime.trailer.images?.large_image_url,
                  description: `צפה בטריילר של ${title}`,
                }
              : undefined,
          }),
        }}
      />
    </Helmet>
  )
}
